'use client';

import { FC, useEffect } from 'react';

import { BaseCarData } from 'src/types/Car.types';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

import { formatViewItemListEvent } from './PlpAnalyticsEvent.helper';

interface Props {
  page: number;
  pages: number;
  currentSlug: string;
  sort: string;
  data: BaseCarData[];
}

/**
 * Trigger the `view_item_list` event on PLP
 */
export const PlpAnalyticsEvent: FC<Props> = ({ page, pages, currentSlug, sort, data }) => {
  useEffect(() => {
    const analyticsEvent = formatViewItemListEvent(page, pages, currentSlug, sort, data);
    if (analyticsEvent) {
      pushToDataLayer(analyticsEvent);
    }
  }, [page, pages, currentSlug, sort, data]);

  return null;
};
